import { Subject } from 'rxjs';
import { Component, EventEmitter, Input, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import { User } from 'src/app/shared/models/user.model';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { ReplaySubject } from 'rxjs/internal/ReplaySubject';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';
import { SubscribedNotification } from 'src/app/shared/models/notification.model';

export enum UseRoles {
  Admin = 'Admin',
  Supplier = 'Supply Chain/Supplier',
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  @Input() notificationList: SubscribedNotification;
  @Output() notificationCount = new EventEmitter();

  usersInfo: User;
  notificationTag: boolean = false;
  userFullName: string;
  userRole: string;
  help_icon: boolean;
  select_icon: boolean;
  isNotificationAvailable: boolean ;
  private unsubscribe: Subject<void> = new Subject<void>();
  environmentName: string;
  themingState: string;
  

  constructor(private renderer: Renderer2, private userRepositoryService: UserRepositoryService, private authService: AuthService) { }

  ngOnInit(): void {
    this.environmentName = environment.envt;

    this.userRepositoryService.getMe().subscribe((user: User) => {
      this.usersInfo = user;
    });

    this.userRepositoryService.loggedUserData$.pipe(
      takeUntil(this.unsubscribe)).subscribe((user: User) => {
        this.userFullName = user.firstName + ' ' + user.lastName;
        this.userRole = user.roleName;
        this.usersInfo = user;
        this.themingState = this.getSavedTheme();
        this.themingState === AppConstants.lightTheme ? this.toLightTheme() : this.toDarkTheme();
        if(user)
        {
          this.onNotificationAvailable(user.cwsId);
        }
      });
      this.registerCloseNotiDrawer();


  }


  toDarkTheme(): void {
    this.renderer.removeClass(document.body, AppConstants.lightTheme);
    this.renderer.addClass(document.body, AppConstants.darkTheme);
    this.help_icon = true;
    this.select_icon = false;
    this.persistThemePreference(AppConstants.darkTheme);
  }
  toLightTheme(): void {
    this.renderer.removeClass(document.body, AppConstants.darkTheme);
    this.renderer.addClass(document.body, AppConstants.lightTheme);
    this.select_icon = true;
    this.help_icon = false;
    this.persistThemePreference(AppConstants.lightTheme);
  }
  onDarkThemeClick() {
    this.toDarkTheme();
  }
  onLightThemeClick() {
    this.toLightTheme();
  }

  private getSavedTheme(): string {
    try {
      const savedTheme = window.localStorage.getItem(AppConstants.themeStorageKey);
      if (savedTheme === AppConstants.lightTheme || savedTheme === AppConstants.darkTheme) {
        return savedTheme;
      }
    } catch {
      // Fallback handled by default theme when storage is unavailable.
    }

    return AppConstants.defaultTheme;
  }

  private persistThemePreference(theme: string): void {
    try {
      window.localStorage.setItem(AppConstants.themeStorageKey, theme);
    } catch {
      // Ignore storage errors; theme still applies for the current session.
    }
  }

  public completeLogout() {
    this.authService.completeLogout();
  }

  onNotificationAvailable(cwsId){
    let totalNotification: number = 0;
    this.userRepositoryService.getNotificationsInfoByUserId(cwsId)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe((notificationList) => {
      for(var i=0; i < notificationList.subscribedNotification.length; i++){
        totalNotification += notificationList.subscribedNotification[i].uploadCount ;
      }

        if(totalNotification){
        this.isNotificationAvailable= totalNotification == 0 ? false : true; 
       }
       
  });
  }

  notificationShow(){
    this.notificationTag = !this.notificationTag;
    this.userRepositoryService.appSettingsClose.next(true);
    this.userRepositoryService.isUploadDrawerClose.next(true);
  }

  closeNotification(){
    this.notificationTag = false;
    this.userRepositoryService.appSettingsClose.next(false);
    this.userRepositoryService.isUploadDrawerClose.next(false);
  }
  
  notificationCountVal(event){
    let notificationCount=event;
    if(notificationCount){
      this.isNotificationAvailable= notificationCount == 1 ? false : true;
    }
  }
  private registerCloseNotiDrawer(){
  this.userRepositoryService.closeNotification.pipe(
    takeUntil(this.unsubscribe)).subscribe(value=>{
    if(value){
     this.closeNotification();
    }
  })
  }
  
}
